import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PaginatorParams } from '../../../../core/model/pagination/paginator-params';
import { PageInfo } from '../../../../core/model/pagination/page-info';

@Component({
    selector: 'ssf-paginator',
    template: require('./paginator.component.html'),
    styles: [require('./paginator.component.scss')]
})
export class PaginatorComponent {
    @Input() state: PaginatorParams;
    @Output() pageChanged = new EventEmitter<PageInfo>();
    public pagesVisibleCount = 5;

    changePage(event: PageInfo) {
        if (this.state.pageInfo.page === event.page  &&  this.state.pageInfo.itemsPerPage === event.itemsPerPage) {
            return;
        }

        this.pageChanged.emit(event);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/components/paginator/paginator.component.ts